import React from "react";

import { Button, ModalBody, ModalFooter, ModalHeading } from "@braze/beacon-core";

import useI18nNamespace from "@services/useI18nNamespace";

import { BrazeModal } from "@components/BrazeModal";

import { getFetchErrorModalAction } from "./utils/getFetchErrorModalAction";
import { FetchErrorModalBody } from "./FetchErrorModalBody";
import { FetchErrorModalTitle } from "./FetchErrorModalTitle";
import type { FetchErrorModalProps } from "./types";

/**
 * For server errors that require user notification and potentially actions, this modal is invoked by
 * the @lib/fetch `fetch` and `fetchWithRetry` functions.
 */
export const FetchErrorModal = ({ error, closeModal }: FetchErrorModalProps): React.ReactElement | null => {
  const { t } = useI18nNamespace("server-fetch-error-messages");

  if (!error) {
    return null;
  }

  const handleClose = () => {
    closeModal();
    getFetchErrorModalAction(error)();
  };

  return (
    <BrazeModal
      isOpen
      onOperatorClose={handleClose}
      operatorLabel={t("fetch-error-modal-operator-label", "Error message modal")}
    >
      <ModalHeading>
        <FetchErrorModalTitle error={error} />
      </ModalHeading>
      <ModalBody>
        <FetchErrorModalBody error={error} />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClose}>{t("ok-button-label", "OK")}</Button>
      </ModalFooter>
    </BrazeModal>
  );
};
